import React, { useMemo } from 'react';
import { Container } from '@plone/components';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import SponsorLevel from '@plone-collective/volto-techevent/components/Sponsors/SponsorLevel';
import { useEventSettings } from '@plone-collective/volto-techevent/hooks/useEventSettings';
import { useSponsors } from '@plone-collective/volto-techevent/hooks/useSponsors';

const SponsorsShowcaseView = ({
  data,
  className,
  style,
  isEditMode = false,
}) => {
  const { title, styles } = data;
  const eventRoot = useEventSettings()?.eventRoot;
  const sponsorsRoot = eventRoot && eventRoot.length > 0 ? eventRoot : '/';
  const { levels, loading, error } = useSponsors(sponsorsRoot);

  const visibleLevels = useMemo(
    () =>
      (levels ?? []).filter(
        (level) => level.has_sponsors && (level.items?.length ?? 0) > 0,
      ),
    [levels],
  );

  const hasLevels = visibleLevels.length > 0;
  const blockClassName = className
    ? `block sponsors conf-sponsors-showcase ${className}`
    : 'block sponsors conf-sponsors-showcase';
  const emptyClassName = isEditMode
    ? 'conf-sponsors-empty is-edit-mode'
    : 'conf-sponsors-empty';

  return (
    <Container className={blockClassName} style={style}>
      {title && <Container className="sponsors title">{title}</Container>}

      <p className="conf-sponsors-intro">
        Partners and organizers supporting Plone Conference 2026.
      </p>

      {loading && <p className="conf-sponsors-status">Loading sponsors...</p>}

      {error && (
        <p className="conf-sponsors-status is-error">
          Sponsors are temporarily unavailable.
        </p>
      )}

      {hasLevels && (
        <div className="sponsor-levels">
          {visibleLevels.map((level) => (
            <section className="conf-sponsor-level" key={level.id}>
              <SponsorLevel item={level} styles={styles} />
            </section>
          ))}
        </div>
      )}

      {!loading && !error && !hasLevels && (
        <div className={emptyClassName}>
          <p>
            {isEditMode
              ? 'Publish sponsor entries under /sponsors to populate this section.'
              : 'Sponsor logos will appear here as soon as entries are published.'}
          </p>

          {!isEditMode && (
            <UniversalLink className="button" href="/sponsors">
              Explore sponsorship
            </UniversalLink>
          )}
        </div>
      )}
    </Container>
  );
};

export default SponsorsShowcaseView;
